import { getRoleName } from "@ext/enterprise/components/admin/settings/components/roles/Access";
import type { MemberAccess } from "@ext/enterprise/components/admin/settings/members/model/Member";
import t from "@ext/localization/locale/translate";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogIcon,
	AlertDialogTitle,
} from "@ui-kit/AlertDialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@ui-kit/Table";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

interface EditorRevokeDialogProps {
	isOpen: boolean;
	accesses: MemberAccess[];
	onConfirm: () => void;
	onCancel: () => void;
}

export const EditorRevokeDialog = ({ isOpen, accesses, onConfirm, onCancel }: EditorRevokeDialogProps) => {
	return (
		<AlertDialog onOpenChange={(open) => !open && onCancel()} open={isOpen}>
			<AlertDialogContent status="warning">
				<AlertDialogHeader>
					<AlertDialogIcon icon="alert-circle" />
					<AlertDialogTitle>{t("enterprise.admin.users.editor-revoke.title")}</AlertDialogTitle>
					<AlertDialogDescription>
						{t("enterprise.admin.users.editor-revoke.description")}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<div className="max-h-60 overflow-y-auto rounded-lg border">
					<Table className="table-fixed">
						<TableHeader className="sticky top-0 [box-shadow:0_1px_0_0_hsl(var(--border))] [&_tr]:border-0">
							<TableRow className="hover:bg-transparent">
								<TableHead>{t("enterprise.admin.users.editor-revoke.catalog-column")}</TableHead>
								<TableHead className="w-40">
									{t("enterprise.admin.users.editor-revoke.role-column")}
								</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody className="[&_tr:last-child]:border-0">
							{accesses.map((access) => (
								<TableRow className="hover:bg-transparent" key={access.resourceId}>
									<TableCell>
										<TextOverflowTooltip>{access.resourceId}</TextOverflowTooltip>
									</TableCell>
									<TableCell className="text-muted">{getRoleName(access.role)}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
				<AlertDialogFooter>
					<AlertDialogCancel type="button" variant="outline">
						{t("cancel")}
					</AlertDialogCancel>
					<AlertDialogAction onClick={onConfirm} type="button">
						{t("enterprise.admin.users.editor-revoke.confirm")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
